import React from 'react';
import { Card, Result, Button } from 'antd';
import { Link } from 'react-router-dom';

const VerifyEmail = () => {
  return (
    <Card className="login-form">
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <img
          src="/images/vouchain-logo.png"
          alt="Vouchain Logo"
          style={{ height: 48, marginBottom: 12 }}
        />
      </div>
      <Result
        status="info"
        title="Email Verification"
        subTitle="This feature is coming soon."
        extra={
          <Link to="/login">
            <Button type="primary">Back to Login</Button>
          </Link>
        }
      />
    </Card>
  );
};

export default VerifyEmail;
